import { Dispatch, SetStateAction, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { formatUSD } from '../../helpers/helperFunctions';
import { CaptionText, P1, P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import { TokenInfo } from './Airdrop.types';
import { AirdropHeaderItem, BlurredValue } from './AirdropsStyled';
import { Link } from 'react-router-dom';
import { Button, SidebarModal } from '../../components';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import {
  Icon,
  IconLock,
  IconTokenTelegram,
  IconTwitter,
  IconWebsite,
  InfoSmallIcon
} from '../../styles/Icons';

import Countdown from 'react-countdown';

import dexscreener from '../../assets/images/backoffice/airDrop/dexscreener.png';
import { Flex } from '../../styles/stylesStyled';
import { Flexed } from '../../styles/GlobalComponents';
import moment from 'moment';

interface KimbaDetailsItemProps {
  airdrop: TokenInfo;
  index: number;
  airdropItem: AirdropItem;
}

interface AirdropItem {
  tokenAmount: number;
  unlockDate: string;
}

export const KimbaDetailsItem = ({
  airdrop,
  airdropItem,
  index
}: KimbaDetailsItemProps) => {
  const CountdownComponent = (dateIso: any) => {
    const date = new Date(dateIso.dateIso);
    const timestamp = date.getTime();

    return (
      <Countdown
        date={timestamp}
        renderer={({ days, hours, minutes }) => (
          <>
            <b>
              {days}D {hours}H {minutes}M
            </b>
          </>
        )}
      />
    );
  };
  return (
    <div style={{ marginTop: 30 }}>
      <Flexed center between>
        <AirdropHeaderItem style={{ alignItems: 'center' }}>
          <Flexed center>
            <img
              src={airdrop.image}
              alt='token'
              style={{ width: '40px', marginRight: 10 }}
            />
            {airdrop.name}
          </Flexed>
        </AirdropHeaderItem>

        <AirdropHeaderItem>
          {formatUSD(Number(airdropItem.tokenAmount))}
        </AirdropHeaderItem>

        <CountdownComponent dateIso={airdropItem.unlockDate} />
        <Button w='100px' h='34px' disabled={true} onClick={() => {}}>
          Claim
        </Button>
      </Flexed>
    </div>
  );
};
